import { render, staticRenderFns } from "./DialogActivityItem.vue?vue&type=template&id=452592aa&"
import script from "./DialogActivityItem.vue?vue&type=script&lang=js&"
export * from "./DialogActivityItem.vue?vue&type=script&lang=js&"
import style0 from "./DialogActivityItem.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports